import { ScriptsExists } from '@fff-web/fff-utilities';
import RECURLY_SCRIPT_SOURCE from './recurlyScriptSource';

export function loadRecurly(): Promise<unknown> {
  if (!ScriptsExists.scriptExists(RECURLY_SCRIPT_SOURCE)) {
    const blockScript = document.createElement('script');
    blockScript.src = RECURLY_SCRIPT_SOURCE;
    blockScript.type = 'text/javascript';
    document.head.appendChild(blockScript);

    return new Promise((resolve) => setTimeout(resolve, 1000));
  }

  return Promise.resolve();
}
